<template>
<div class="tab-pane fade" id="AF-ProfitLoss" role="tabpanel"  aria-labelledby="home-tab">

                <div class="row col-sm-12">
                  
                  <div class="col-sm-5">
                  
                    <div class="input-group input-daterange"><datepicker  value="2019-01-01"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker  value="2019-01-01"></datepicker> </div>
                   
                   
                  
                  </div>
                  <div class="col-sm-1">
                     <button class="btn btn-primary btn-sm" @click="searchButton(searchagt,tab)">Search</button>
                  </div>

                  <div class="col-sm-6">Quick Inquiry
                    <b-button-group size="sm">
                    <b-button>Previous day</b-button>
                    <b-button>Today</b-button>
                    <b-button>Last Week</b-button>
                    <b-button>This Week</b-button>
                    <b-button>Last Month</b-button>
                    <b-button>This Month</b-button>
                    </b-button-group>
                  </div>

                </div>
                 <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                    <table class="table table-bordered table-striped table-hover table-dark" >

                      <thead>
                        <tr>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Option</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Class</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Username</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game</th>
                          <th
                          scope="row"
                  
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Total Bet Amount</th>
                          <th
                          scope="row"
       
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Win/Lost</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Valid Bet Amount</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Type</th>
                          <th
                          scope="row"
             
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Net P/L</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Share %</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Total Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Win/Lost</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Valid Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Actual Settlement</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Shareholder Win %</th>
                        </tr>

                        
                      </thead>
                      <tbody>

                        <tr>
                          <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary">Details</button></td>
                          <td class="text-center" style="vertical-align: middle;">
                            Top Agent<br/>
                           
                          </td>
                          <td class="text-center" style="vertical-align: middle;">Username</td>
                          <td class="text-center" style="vertical-align: middle;">I , H3 , I3 , VIP_Y1</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">Below</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
                <div style="padding-top:30px;">
                  <div class="b-b b-theme nav-active-theme mb-3">
                     <ul class="nav nav-pills" id="myTabchild">
                        <li class="nav-item">
                        <a 
                        class="nav-link active" 
                        id="reportsa"
                        data-toggle="tab" 
                        href="#childreportsa"
                        role="tab" 
                        aria-controls="home" 
                        aria-selected="true">
                        Direct Inferior Agent P/L Report
                      </a>
                    </li>

                     <li class="nav-item">
                        <a 
                        class="nav-link" 
                        id="reportsa"
                        data-toggle="tab" 
                        href="#clientsa"
                        role="tab" 
                        aria-controls="home" 
                        >
                        Direct Inferior Client P/L Report
                      </a>
                    </li>
                     </ul>
                   </div>
                   <div class="tab-content mb-4">
                  <div class="tab-pane fade active show" id="childreportsa" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                     <h3>Agent </h3>
                    
                    <div class="table-responsive">
                    <table class="table table-bordered table-striped table-hover table-dark v-middle dataTable" id="datatable1" role="grid" aria-describedby="datatable_info"> 
                      <thead>
                        <tr>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Option</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Class</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Username</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game</th>
                          <th
                          scope="row"
                  
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Total Bet Amount</th>
                          <th
                          scope="row"
       
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Win/Lost</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Valid Bet Amount</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Type</th>
                          <th
                          scope="row"
             
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Net P/L</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Share %</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Total Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Win/Lost</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Valid Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Actual Settlement</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Shareholder Win %</th>
                        </tr>

                 
                      </thead>
                      <tbody>

                        <tr>
                          <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary">Details</button></td>
                          <td class="text-center" style="vertical-align: middle;">
                            Top Agent<br/>
                           
                          </td>
                          <td class="text-center" style="vertical-align: middle;">Username</td>
                          <td class="text-center" style="vertical-align: middle;">I , H3 , I3 , VIP_Y1</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">Below</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
                      </div>

                  <div class="tab-pane fade" id="clientsa" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                    <h3>Client </h3>
                    <table class="table table-bordered table-striped table-hover table-dark">
                      <thead>
                        <tr>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Option</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Class</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Username</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Game</th>
                          <th
                          scope="row"
                  
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Total Bet Amount</th>
                          <th
                          scope="row"
       
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Win/Lost</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Valid Bet Amount</th>
                          <th
                          scope="row"
              
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Type</th>
                          <th
                          scope="row"
             
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Rebate Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Net P/L</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Share %</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Total Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Win/Lost</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Commit Shareholder Valid Bet Amount</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Actual Settlement</th>
                          <th
                          scope="row"
                          rowspan="2"
                          class="text-center"
                          style="vertical-align: middle;"
                          >Shareholder Win %</th>
                        </tr>

                 
                      </thead>
                      <tbody>

                        <tr>
                          <td class="text-center" style="vertical-align: middle;"><button class="btn btn-primary">Details</button></td>
                          <td class="text-center" style="vertical-align: middle;">
                            Top Agent<br/>
                           
                          </td>
                          <td class="text-center" style="vertical-align: middle;">Username</td>
                          <td class="text-center" style="vertical-align: middle;">I , H3 , I3 , VIP_Y1</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">Below</td>
                          <td class="text-center" style="vertical-align: middle;"></td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">0.00</td>
                          <td class="text-center" style="vertical-align: middle;">
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
                      </div>
                   </div>
                </div>
                </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';

export default {
  name: "afprofitlossreport",
  components: {
    Datepicker
  }
}
</script>